























import { Vue, Component, Inject } from "vue-property-decorator";

// Enums/Data
import { IContractCancellationProvider as ICCProvider } from "@/models/providers/contractCancellation";

@Component
export default class ContractMoneyBackPeriod extends Vue {
  // Inject

  @Inject({ from: "contractCancellationProvider" })
  public readonly $provider!: () => ICCProvider;

  public get providerData() {
    return this.$provider();
  }

  // Computed

  public get activationDate() {
    return this.$_.get(this.providerData, "contractProduct.activation_date");
  }

  public get moneyBackPeriod() {
    return this.$_.get(
      this.providerData,
      "contractProduct.recommended_money_back_period"
    );
  }

  public get calculatedMoneyBackEndDate() {
    const activationDate = new Date(this.activationDate);

    return this.$moment(activationDate).add(this.moneyBackPeriod, "days");
  }
}
